import {
    Breakpoints,
    Text,
    TextAlignment,
    TextTag,
    styled,
    TokenTextAppearance,
} from '@volkswagen-onehub/components-core'
import React, {useMemo} from 'react'
import {useTranslation} from 'react-i18next'
import {formatListTitle} from '../../../utils/promos/formatListTitle'

const ShowRoomTitleWrapper = styled.section`
    margin-bottom: 30px;
`

const Title = styled(Text)`
    font-size: 32px;
    line-height: 1.2;

    @media (min-width: ${Breakpoints.b560}px) {
        font-size: 48px;
    }
`

export interface ShowRoomTitleProps {
    modelHasPromos: boolean
    modelName?: string
    modelNames?: string[]
    showNoPromoMessage?: boolean
}

export default function ShowroomTitle(
    props: ShowRoomTitleProps
): React.JSX.Element {
    const {t} = useTranslation('app')

    const namesFormatted = useMemo(() => {
        if (props.modelNames && props.modelNames.length) {
            return formatListTitle(props.modelNames)
        }

        return props.modelName ?? ''
    }, [props.modelNames, props.modelName])

    const hasNames = !!namesFormatted
    const showNoPromoMessage = props.showNoPromoMessage ?? !props.modelHasPromos
    const textString = showNoPromoMessage
        ? t('showroom.textNoPromo')
        : hasNames
        ? t('showroom.text', {modelName: namesFormatted})
        : ''

    return (
        <ShowRoomTitleWrapper>
            <Title
                tag={TextTag.h2}
                textAlign={TextAlignment.center}
                appearance={TokenTextAppearance.headline300}
                bold={true}
            >
                {t('showroom.title')}
            </Title>

            {textString ? (
                <Text tag={TextTag.p} textAlign={TextAlignment.center}>
                    {textString}
                </Text>
            ) : undefined}
        </ShowRoomTitleWrapper>
    )
}
